import { AUTRE } from '@/configuration/bodac/typeContact/typeContactConf';

export default function genererTypeContact() {
  return {
    libelle: '',
    typeContactType: AUTRE,
  };
}
